import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';


import { EveReportingWidgetDataSourceType } from '../../components/widgets/widget-menu-settings/widget-datasource/widget-datasource.component';
import { Multi } from '../../interfaces/multi.interface';
import { ControlWidgetService } from '../ControlWidgetService.service';
import { EveReportingWidget } from '../../components/widgets/widget.component';
import { EveMultiDataSourceService } from './EveMultiDataSourceService.service';
import { EveSingleDataSourceService } from './EveSingleDataSourceService.service';
import { EveReportingWidgetMultiDataSource } from '../../components/widgets/widget-menu-settings/widget-datasource/widget-multi-datasource/widget-multi-datasource.component';
import { EveReportingWidgetSingleDataSource } from '../../components/widgets/widget-menu-settings/widget-datasource/widget-single-datasource/widget-single-datasource.component';
import { iDataSource, IDataSourceService } from './IDataSourceService.service';
import { IGraphQlService } from '../GraphQl/IGraphQL.service';
import { Single } from '../../interfaces/single.interface';
import { GlobalFiltersOptionalService } from './GlobalFiltersOptionalService.service';

@Injectable()
export class DataSourceService implements IDataSourceService {
  constructor(
    public graphQlService: IGraphQlService,
    public controlWidgetService: ControlWidgetService,
    public eveMultiDataSourceService: EveMultiDataSourceService,
    public eveSingleDataSourceService: EveSingleDataSourceService,
  ) { }


  

  MultiResults(eveReportingWidget: BehaviorSubject<EveReportingWidget>, staticData: Multi[]): Observable<Multi[]>  {

    return eveReportingWidget.pipe(
      
      switchMap(eveReportingWidget => {
        const dataSource = ((eveReportingWidget as any) as iDataSource)?.dataSource;
        if (dataSource?.type == EveReportingWidgetDataSourceType.EveMultiChart && (dataSource as EveReportingWidgetMultiDataSource).queryField != null) {

          return this.eveMultiDataSourceService.EveMultiDataSourceResults(eveReportingWidget);
          
        }
        else return of(staticData)
      })
    )
  }

  SingleResults(eveReportingWidget: BehaviorSubject<EveReportingWidget>, staticData: Single[]): Observable<Single[]> {

    return eveReportingWidget.pipe(
      switchMap(eveReportingWidget => {
        const dataSource = ((eveReportingWidget as any) as iDataSource)?.dataSource;
        if (dataSource?.type == EveReportingWidgetDataSourceType.EveSingleChart && (dataSource as EveReportingWidgetSingleDataSource).queryField != null) {
          return this.eveSingleDataSourceService.EveSingleDataSourceResults(eveReportingWidget);
        }
        else return of(staticData)
      })
    )
  }
}
